import { useAuth } from "context/AuthContext";
import { useEffect, useCallback, useRef } from "react";

type UseAutoLogoutOptions = {
  timeout?: number;
};

const useAutoLogout = ({
  timeout = 60 * 10 * 1000,
}: UseAutoLogoutOptions = {}) => {
  const timer = useRef<NodeJS.Timeout | null>(null);
  const { logout } = useAuth();

  const resetTimer = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      console.log("Auto logout");
      logout();
    }, timeout);
  }, [timeout, logout]);

  useEffect(() => {
    const activityHandler = () => resetTimer();
    window.addEventListener("mousemove", activityHandler);
    window.addEventListener("keydown", activityHandler);
    window.addEventListener("scroll", activityHandler);
    window.addEventListener("click", activityHandler);

    resetTimer();

    return () => {
      window.removeEventListener("mousemove", activityHandler);
      window.removeEventListener("keydown", activityHandler);
      window.removeEventListener("scroll", activityHandler);
      window.removeEventListener("click", activityHandler);

      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, [resetTimer]);

  return { resetTimer };
};

export default useAutoLogout;
